import { I2cTextarea } from "@webcomponents/i2cwebcomponents/dist/react";
import React, { useEffect } from "react";
import "../Prepaid.scss";

const AdditionalComment = ({
  setAddFormData,
  addFormData,
  formDataJson,
  setFormValidStates,
  isFetching,
}) => {
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      setAddFormData({
        ...addFormData,
        9: {
          "9_0": {
            additional_comment:
              formDataJson["9"]["9_0"]?.additional_comment ?? "",
          },
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetching]);
  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-sm">
          <div i2c-grid="12">
            <div className="custom-label-light  mb-16">
              If there is any detail that was not covered in the sections above,
              please mention it here in this section.
            </div>
            <I2cTextarea
              name="additionalComment"
              label=""
              placeholder="Enter Additional Comments"
              autofocus
              value={
                addFormData["9"]
                  ? addFormData["9"]["9_0"]?.additional_comment
                  : ""
              }
              onI2cInput={(e) => {
                setFormValidStates("9_0", true);
                setAddFormData({
                  ...addFormData,
                  9: {
                    "9_0": { additional_comment: e?.target?.value ?? "" },
                  },
                });
              }}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default AdditionalComment;
